export const FETCH_VEHICLE_CHECK_MODELS = 'VEHICLE_CHECK_MODELS/FETCH_REQUEST';
export const FETCH_VEHICLE_CHECK_MODELS_SUCCESS = 'VEHICLE_CHECK_MODELS/FETCH_SUCCESS';
export const FETCH_VEHICLE_CHECK_MODELS_FAILURE = 'VEHICLE_CHECK_MODELS/FETCH_FAILURE';

export const FETCH_VEHICLE_CHECK_MODEL = 'VEHICLE_CHECK_MODEL/FETCH_REQUEST';
export const FETCH_VEHICLE_CHECK_MODEL_SUCCESS = 'VEHICLE_CHECK_MODEL/FETCH_SUCCESS';
export const FETCH_VEHICLE_CHECK_MODEL_FAILURE = 'VEHICLE_CHECK_MODEL/FETCH_FAILURE';

export const FETCH_DEFAULT_VEHICLE_CHECK_MODEL = 'VEHICLE_CHECK_MODEL/DEFAULT/FETCH_REQUEST';
export const FETCH_DEFAULT_VEHICLE_CHECK_MODEL_SUCCESS = 'VEHICLE_CHECK_MODEL/DEFAULT/FETCH_SUCCESS';
// eslint-disable-next-line no-unused-vars
const FETCH_DEFAULT_VEHICLE_CHECK_MODEL_FAILURE = 'VEHICLE_CHECK_MODEL/DEFAULT/FETCH_FAILURE';

export const DELETE_VEHICLE_CHECK_MODEL = 'VEHICLE_CHECK_MODELS/DELETE_REQUEST';
export const DELETE_VEHICLE_CHECK_MODEL_SUCCESS = 'VEHICLE_CHECK_MODELS/DELETE_SUCCESS';
export const DELETE_VEHICLE_CHECK_MODEL_FAILURE = 'VEHICLE_CHECK_MODELS/DELETE_FAILURE';

export const CLONE_VEHICLE_CHECK_MODEL = 'VEHICLE_CHECK_MODELS/CLONE_REQUEST';
export const CLONE_VEHICLE_CHECK_MODEL_SUCCESS = 'VEHICLE_CHECK_MODELS/CLONE_SUCCESS';
export const CLONE_VEHICLE_CHECK_MODEL_FAILURE = 'VEHICLE_CHECK_MODELS/CLONE_FAILURE';

export const CREATE_VEHICLE_CHECK_MODEL = 'VEHICLE_CHECK_MODELS/CREATE_REQUEST';
export const CREATE_VEHICLE_CHECK_MODEL_SUCCESS = 'VEHICLE_CHECK_MODELS/CREATE_SUCCESS';
export const CREATE_VEHICLE_CHECK_MODEL_FAILURE = 'VEHICLE_CHECK_MODELS/CREATE_FAILURE';

export const UPDATE_VEHICLE_CHECK_MODEL = 'VEHICLE_CHECK_MODELS/UPDATE_REQUEST';
export const UPDATE_VEHICLE_CHECK_MODEL_SUCCESS = 'VEHICLE_CHECK_MODELS/UPDATE_SUCCESS';
export const UPDATE_VEHICLE_CHECK_MODEL_FAILURE = 'VEHICLE_CHECK_MODELS/UPDATE_FAILURE';

export const DETAILS_PAGE_IS_READY = 'VEHICLE_CHECK_MODEL/DETAILS/READY';
export const DESTROY_SELECT = 'VEHICLE_CHECK_MODELS/SELECT/DESTROY';
